module.exports = __webpack_public_path__ + "static/img/xAxis.ce43f52e.svg";